// extracted by mini-css-extract-plugin
module.exports = {"plus":"Option_plus__pRN0h","hidden":"Option_hidden__eHWlY"};